export function formatHeightFromCm(value) {
  if (value === null || typeof value === 'undefined' || value === '') {
    return '';
  }

  const original = String(value).trim();
  if (!original) return '';

  // Keep values that are already stored in feet/inches.
  if (/['"]|\bft\b|\bfeet\b/i.test(original)) {
    return original;
  }

  const match = original.match(/\d+(?:\.\d+)?/);
  const centimetres = match ? Number(match[0]) : NaN;
  if (!Number.isFinite(centimetres) || centimetres <= 0) {
    return original;
  }

  const totalInches = Math.round(centimetres / 2.54);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;

  return `${feet}'${inches}"`;
}

export function replaceCmHeights(text) {
  if (typeof text !== 'string' || !text) return text;

  return text.replace(/\b(\d{2,3}(?:\.\d+)?)\s*cm\b/gi, (matched, value) => {
    return formatHeightFromCm(value) || matched;
  });
}

export function convertCmTextInElement(root) {
  if (!root || typeof document === 'undefined') return;

  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );
  const nodes = [];

  while (walker.nextNode()) {
    const node = walker.currentNode;
    const parentName = node.parentElement && node.parentElement.tagName;
    if (!/^(SCRIPT|STYLE|TEXTAREA|INPUT)$/i.test(parentName || '') && /\d\s*cm\b/i.test(node.nodeValue || '')) {
      nodes.push(node);
    }
  }

  nodes.forEach(node => {
    node.nodeValue = replaceCmHeights(node.nodeValue);
  });
}
